import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "../i18n";
import api, { apiErr } from "../lib/api";
import { Sparkles, Loader2 } from "lucide-react";

export default function JournalPanel({ refreshKey }) {
  const { t } = useLang();
  const [entries, setEntries] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => { api.get("/journal").then((r) => setEntries(r.data.entries)).catch(() => {}); };
  useEffect(() => { load(); }, [refreshKey]);

  const generate = async () => {
    setBusy(true);
    try { await api.post("/journal/generate"); load(); toast.success("Journal IA généré"); }
    catch (e) { toast.error(apiErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="border border-[#1E2028] bg-[#0F1015]">
      <div className="flex items-center justify-between p-4 border-b border-[#1E2028]">
        <div className="flex items-center gap-2 text-sm font-display font-bold">
          <Sparkles className="w-4 h-4 text-[#FACC15]" /> {t("journal")}
        </div>
        <button data-testid="generate-journal" onClick={generate} disabled={busy}
          className="flex items-center gap-2 bg-[#FACC15] text-[#05050A] text-xs font-semibold px-3 py-2 hover:bg-[#eab308] transition-colors duration-200 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}
          {t("generateJournal")}
        </button>
      </div>
      <div className="p-4 space-y-3 max-h-[420px] overflow-y-auto">
        {entries.length === 0 ? (
          <div className="py-12 text-center text-sm text-[#6B7280] font-mono">{t("noJournal")}</div>
        ) : entries.map((e) => (
          <div key={e.id} data-testid="journal-entry" className="border-l-2 border-[#FACC15] bg-[#05050A] p-3">
            <div className="text-[10px] text-[#6B7280] font-mono mb-1 flex items-center gap-2">
              {e.kind === "auto" && <span className="text-[#8B5CF6] border border-[#8B5CF6]/40 px-1">AUTO{e.symbol ? ` · ${e.symbol}` : ""}</span>}
              {new Date(e.created_at).toLocaleString()}
            </div>
            <p className="text-sm text-[#D1D5DB] leading-relaxed whitespace-pre-line">{e.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
